var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelpOutline = function SvgHelpOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.833 12h1.334v-1.333H7.833zM8.5 1.334A6.67 6.67 0 0 0 1.833 8 6.67 6.67 0 0 0 8.5 14.667 6.67 6.67 0 0 0 15.167 8 6.67 6.67 0 0 0 8.5 1.334m0 12A5.34 5.34 0 0 1 3.167 8 5.34 5.34 0 0 1 8.5 2.667 5.34 5.34 0 0 1 13.833 8 5.34 5.34 0 0 1 8.5 13.334M8.5 4a2.666 2.666 0 0 0-2.667 2.667h1.334c0-.733.6-1.333 1.333-1.333s1.333.6 1.333 1.333c0 1.333-2 1.167-2 3.333h1.334c0-1.5 2-1.666 2-3.333A2.666 2.666 0 0 0 8.5 4"
  })));
};
export default SvgHelpOutline;